import bg from '../assets/images/bg-2.jpg'
import { Outlet, NavLink , Link} from "react-router-dom"

export default function Home() {
  return (
<section className="hero">

<div className="hero-content" dir='rtl'>

   
   <h1 className='hero-title title-anm text-center'>
            <span>   أهلا </span>
            <span>  بكم </span>
            <span> في</span>
            <span> موقع</span><br></br>
            <span className="text-primary-color revealUp"> 1sTest </span>
           </h1>  
   <p className='p-anm hero-subtitle'>نقدم اختبارات السياقة النظرية للدراسة مجانا! تعتمد الاختبارات في الموقع على قاعدة بيانات الأسئلة الرسمية التابعة لوزارة السير،<br></br> لذا فهي تحاكي الاختبار النظري الحقيقي بأكثر الطرق دقة.  </p>
     <br></br>
     <h1 className='text-primary-color h-anm'> حظا سعيدا في الاختبار! </h1><br></br>
   <button type="button" className="hero-button h-anm" onClick={e=>(window.location.href='start')}>
   ابدأ &raquo;
   </button>

</div>

</section>
    // <div className="container home" dir="rtl">
    //  
    //   <div className="hero-image">
    //     <div className="hero-text ">
    //       <h1 className='title-anm'>
    //         <span>   أهلا </span>
    //         <span>  بكم </span>
    //         <span> في</span>
    //         <span> موقع</span><br></br>
    //         <span className="text-primary-color revealUp"> 1sTest </span>

    //       </h1>
       

    //       <p className='p-anm'>نقدم اختبارات السياقة النظرية للدراسة مجانا! تعتمد الاختبارات في الموقع على قاعدة بيانات الأسئلة الرسمية التابعة لوزارة السير، لذا فهي تحاكي الاختبار النظري الحقيقي بأكثر الطرق دقة.  </p>
        
    //       <h1 className='text-primary-color h-anm'> حظا سعيدا في الاختبار! </h1>
          
    //       <nav className="nav-btn">
    //       <NavLink to="start" className='link link-about h-anm '>ابدأ </NavLink>
            

    //       </nav>
    //     </div>
    //   </div>
    //   <div className="container-bg">
    //     <img src={bg} className='img-bg'></img>

    //   </div>
    // </div>
  )
}
